import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as colors from '../../../styles/colors';

const DropDownItem = ({ to, title }) => (
  <Wrapper>
    <LinkStyled to={to}>
      <Dot />
      <Text>{title}</Text>
    </LinkStyled>
  </Wrapper>
);

DropDownItem.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Dot = styled.div`
  display: inline-block;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: ${colors.sideBarText};
  margin-right: 10px;
`;
const Text = styled.span`
  font-size: 0.9rem;
  font-weight: 300;
`;
const LinkStyled = styled(Link)`
  text-decoration: none;
  color: ${colors.sideBarText};
  display: flex;
  align-items: center;
  padding-left: 55px;
  height: 40px;
  width: 100%;
  :hover {
    color: ${colors.sideBarText};
    background-color: #1a1a27;
    text-decoration: none;
  }
`;
export default DropDownItem;
